var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"social-proof"},[_c('div',{staticClass:"d-flex"},_vm._l((_vm.avatarImages),function(img,index){return _c('AvatarItem',{key:index,attrs:{"src-path":img}})}),1),_c('div',{staticClass:"rating-info"},[_c('banner-stars',{attrs:{"count":5}}),_c('div',[_vm._v("Loved by 100,000+ Teachers")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }